import { useState } from "react";
import { toast } from "sonner";
import { useApi, errMsg } from "@/lib/api";

const STATUS = { pending: "text-amber-300 border-amber-500/40", approved: "text-emerald-300 border-emerald-500/40", rejected: "text-rose-300 border-rose-500/40", retired: "text-slate-400 border-white/10" };
const ACTIONS = { pending: [["approved", "Approve"], ["rejected", "Reject"]], approved: [["retired", "Retire"]], rejected: [["pending", "Reconsider"]], retired: [["approved", "Re-approve"]] };

export const tagText = (t = {}) => [t.track, t.state, t.condition, t.distance, ...(t.topics || [])].filter(Boolean).join(" · ") || "All races";

export const LessonItem = ({ l, onChange }) => {
  const api = useApi();
  const [edit, setEdit] = useState(false);
  const [text, setText] = useState(l.text);
  const save = async (patch) => {
    try {
      onChange(await api("patch", `/analyst/lessons/${l.id}`, patch));
      setEdit(false);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <li className="rounded-xl border border-white/5 bg-[#0B101D] p-3 space-y-2" data-testid={`lesson-${l.id}`}>
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-widest">
        <span className={`border rounded px-1.5 py-0.5 ${STATUS[l.status]}`} data-testid={`lesson-status-${l.id}`}>{l.status}</span>
        <span className="text-slate-500 truncate">{tagText(l.tags)}</span>
      </div>
      {edit
        ? <textarea data-testid={`lesson-text-input-${l.id}`} value={text} onChange={(e) => setText(e.target.value)} rows={3} maxLength={400} className="w-full bg-[#131C31] border border-white/10 rounded-lg p-2 text-sm" />
        : <p className="text-sm text-slate-200">{l.text}</p>}
      {l.source && <p className="text-[11px] text-slate-500">From {l.source.track} R{l.source.race_number} · {l.source.date}</p>}
      <div className="flex flex-wrap gap-2">
        {edit
          ? <>
            <button data-testid={`lesson-save-${l.id}`} onClick={() => save({ text })} className="px-3 py-1 rounded-full bg-blue-600 text-xs font-semibold">Save</button>
            <button data-testid={`lesson-cancel-${l.id}`} onClick={() => setEdit(false)} className="px-3 py-1 rounded-full border border-white/10 text-xs text-slate-300">Cancel</button>
          </>
          : <button data-testid={`lesson-edit-${l.id}`} onClick={() => { setText(l.text); setEdit(true); }} className="px-3 py-1 rounded-full border border-white/10 text-xs text-slate-300">Edit</button>}
        {ACTIONS[l.status].map(([s, label]) => (
          <button key={s} data-testid={`lesson-${s}-${l.id}`} onClick={() => save({ status: s })} className={`px-3 py-1 rounded-full text-xs font-semibold ${s === "approved" ? "bg-emerald-600" : "border border-white/10 text-slate-300"}`}>{label}</button>
        ))}
      </div>
    </li>
  );
};
